// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xYybu{display:flex;flex-direction:column;gap:24px;margin:0;width:100%}.xYybu._3kZjp{gap:24px}.SwbZS{flex-wrap:nowrap;width:100%}.SwbZS.Bzy0j{flex-direction:column;align-items:stretch;gap:24px}._Zww6{flex-shrink:0;margin-left:auto;white-space:nowrap}.Bzy0j ._Zww6{margin-left:0}.xGPfT{display:flex;gap:40px}.ENClm{flex:1}.t4iB_{display:flex;flex-direction:row;gap:16px;align-items:flex-start;width:100%}.t4iB_ .Y4JWw{flex:1 1 0;min-width:0;display:flex;flex-direction:column;gap:4px}.t4iB_.pUrPG{flex-direction:column}.t4iB_.pUrPG .Y4JWw{flex:unset;min-width:unset}.t4iB_.pUrPG .uN4g2{width:100%}.ywxMa{display:contents;gap:16px}.ywxMa.aAi0T{display:flex;flex-direction:row;flex:1 1 0;min-width:0}.ywxMa.aAi0T .Y4JWw{flex:1 1 0}.TYSyJ{display:flex;flex-direction:column;gap:4px}.JdYN0{border:1px solid #bfbfd0 !important;border-radius:4px;padding:8px 12px;background:var(--bg-light, #ffffff) !important;width:100% !important;min-height:48px;box-sizing:border-box}.JdYN0:focus{border-color:var(--button-primary, #6942f8) !important;outline:none}.Ynpxf{border:1px solid #282863 !important;border-radius:4px;padding:8px 12px;background:#fcfcfd !important;width:100% !important;height:48px;min-height:48px;box-sizing:border-box}.Ynpxf:hover:not(.Z3ykG){border-color:var(--button-primary, #6942f8) !important;box-shadow:0 0 0 1px var(--button-primary, #6942f8)}.Ynpxf:focus-within{border-color:var(--button-primary, #6942f8) !important;box-shadow:0 0 0 1px var(--button-primary, #6942f8);outline:none}.Ynpxf.Z3ykG{border-color:#e86161 !important;height:48px;min-height:48px}.Ynpxf.Z3ykG:hover,.Ynpxf.Z3ykG:focus-within{border-color:#e86161 !important;box-shadow:0 0 0 1px #e86161}.xtOGU{display:flex;flex-direction:column;gap:24px}.lghEV{text-align:center}._4zKCT{padding:0 4px;margin:0 !important;margin-top:0 !important;width:100%;box-sizing:border-box;max-width:100%;font-size:12px;line-height:normal}.t0R51{padding:0 4px;margin:0 !important;margin-top:0 !important;width:100%;box-sizing:border-box;max-width:100%;font-size:12px;line-height:normal;color:#e86161}.UZbTt{width:100%}.ywSQB{width:100%}.rV3rf{margin-top:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"formNewUi": `xYybu`,
	"formNewUiMobile": `_3kZjp`,
	"buttonRowNewUi": `SwbZS`,
	"buttonRowNewUiMobile": `Bzy0j`,
	"buttonRowNewUiButton": `_Zww6`,
	"ccExpirationRow": `xGPfT`,
	"ccExpirationField": `ENClm`,
	"expiryCvvZipRow": `t4iB_`,
	"expiryCvvZipField": `Y4JWw`,
	"expiryCvvZipRowMobile": `pUrPG`,
	"zipCodeField": `uN4g2`,
	"expiryCvvWrapper": `ywxMa`,
	"expiryCvvWrapperMobile": `aAi0T`,
	"stripeInputGroup": `TYSyJ`,
	"inputNewUi": `JdYN0`,
	"stripeInput": `Ynpxf`,
	"stripeInputInvalid": `Z3ykG`,
	"buttonSection": `xtOGU`,
	"feeDisclaimerMobile": `lghEV`,
	"helperTextCollapse": `_4zKCT`,
	"helperTextError": `t0R51`,
	"collapseWrapper": `UZbTt`,
	"collapseInner": `ywSQB`,
	"error": `rV3rf`
};
export default ___CSS_LOADER_EXPORT___;
